import Image from "next/image";
import IconTooltip from "@/components/IconTooltip";

export default function Article({article}) {
    //console.log(article)
    return (
        <article key={article.id} className={`flex max-sm:flex-wrap sm:flex-nowrap mb-6`}>
            <a href={article.url} target="_blank" rel="noreferrer" className={`block max-md:w-full md:w-[145px] md:h-[145px] aspect-square relative`}>
                <Image src={article.listingImage.url} placeholder="blur" blurDataURL='/placeholder/placeholder.png' width="200" height="200" alt={article.listingImage.altText} className={`rounded object-cover h-full w-full`}/>
            </a>
            <div className={`mt-3 sm:mt-0 sm:pl-5`}>
                <a href={article.url} target="_blank" rel="noreferrer" className={`block font-bold mb-2`}>
                    {article.title}
                </a>
                {article.listingDescription ?
                    <p className={`text-xs mb-2`}>
                        {article.listingDescription.substring(0, 180)}&hellip;
                        <a href={article.url} target="_blank" rel="noreferrer"> <br className="md:hidden" />Read more</a>
                    </p>
                : null}

                <ul className={`flex max-md:flex-wrap`}>
                    {article.tags.slice(0,3).map((tag, index) =>
                        <li key={index}>
                            <a href={`https://www.nps.gov/search/?query=${tag}&sitelimit=%2F&affiliate=nps`} target="_blank" rel="noreferrer" className={`text-xxs py-1 px-3 bg-beige-30 rounded-full mr-2`}>
                                {tag}
                            </a>
                        </li>
                    )}
                </ul>
            </div>
        </article>
    )
}